export const STKAKING = "Staking";
export const MYSTAKING = "My Staking";
export const SWITCH_GROUP = [STKAKING, MYSTAKING];
